import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"check\"><path d=\"M15 0a15 15 0 1015 15A15.017 15.017 0 0015 0zm6.419 12.555L14.6 19.373a1.363 1.363 0 01-1.928 0l-4.09-4.09a1.363 1.363 0 111.928-1.929l3.126 3.127 5.855-5.854a1.364 1.364 0 011.927 1.929v-.001z\" fill=\"#35CB6A\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol